var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"11.4 5.5 6.9 10.1 5.8 9 8.6 6.3 0.5 6.3 0.5 4.8 8.6 4.8 5.8 2 6.9 0.9 11.4 5.5"}));
}

Arrow.defaultProps = {"viewBox":"0 0 12 11"};

module.exports = Arrow;

Arrow.default = Arrow;
